// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleRouteRouteImport } from './routes/$locale/route'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocaleAboutRouteImport } from './routes/$locale/about'
import { Route as LocaleAccountRouteImport } from './routes/$locale/account'
import { Route as LocaleAppRouteImport } from './routes/$locale/app'
import { Route as LocaleBoosterRemindersRouteImport } from './routes/$locale/booster-reminders'
import { Route as LocaleCommunityRouteImport } from './routes/$locale/community'
import { Route as LocaleContactRouteImport } from './routes/$locale/contact'
import { Route as LocaleCookiesRouteImport } from './routes/$locale/cookies'
import { Route as LocaleDeleteAccountRouteImport } from './routes/$locale/delete-account'
import { Route as LocaleDevelopersRouteImport } from './routes/$locale/developers'
import { Route as LocaleFaqRouteImport } from './routes/$locale/faq'
import { Route as LocaleLoginRouteImport } from './routes/$locale/login'
import { Route as LocaleMediaRouteImport } from './routes/$locale/media'
import { Route as LocalePrivacyRouteImport } from './routes/$locale/privacy'
import { Route as LocaleRegisterRouteImport } from './routes/$locale/register'
import { Route as LocaleTermsRouteImport } from './routes/$locale/terms'
import { Route as LocaleTravelScanRouteImport } from './routes/$locale/travel-scan'
import { Route as LocaleVaccinationChecklistRouteImport } from './routes/$locale/vaccination-checklist'
import { Route as LocaleBlogIndexRouteImport } from './routes/$locale/blog/index'
import { Route as LocaleBlogSlugRouteImport } from './routes/$locale/blog/$slug'
import { Route as LocaleTravelIndexRouteImport } from './routes/$locale/travel/index'
import { Route as LocaleTravelSlugRouteImport } from './routes/$locale/travel/$slug'
import { Route as LocaleTravelDiseasesIndexRouteImport } from './routes/$locale/travel/diseases/index'
import { Route as LocaleTravelDiseasesSlugRouteImport } from './routes/$locale/travel/diseases/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LocaleRouteRoute = LocaleRouteRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRouteRoute
          })
const LocaleAboutRoute = LocaleAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LocaleRouteRoute
          })
const LocaleAccountRoute = LocaleAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => LocaleRouteRoute
          })
const LocaleAppRoute = LocaleAppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => LocaleRouteRoute
          })
const LocaleBoosterRemindersRoute = LocaleBoosterRemindersRouteImport.update({
            id: '/booster-reminders',path: '/booster-reminders',getParentRoute: () => LocaleRouteRoute
          })
const LocaleCommunityRoute = LocaleCommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => LocaleRouteRoute
          })
const LocaleContactRoute = LocaleContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LocaleRouteRoute
          })
const LocaleCookiesRoute = LocaleCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => LocaleRouteRoute
          })
const LocaleDeleteAccountRoute = LocaleDeleteAccountRouteImport.update({
            id: '/delete-account',path: '/delete-account',getParentRoute: () => LocaleRouteRoute
          })
const LocaleDevelopersRoute = LocaleDevelopersRouteImport.update({
            id: '/developers',path: '/developers',getParentRoute: () => LocaleRouteRoute
          })
const LocaleFaqRoute = LocaleFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => LocaleRouteRoute
          })
const LocaleLoginRoute = LocaleLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => LocaleRouteRoute
          })
const LocaleMediaRoute = LocaleMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => LocaleRouteRoute
          })
const LocalePrivacyRoute = LocalePrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LocaleRouteRoute
          })
const LocaleRegisterRoute = LocaleRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => LocaleRouteRoute
          })
const LocaleTermsRoute = LocaleTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => LocaleRouteRoute
          })
const LocaleTravelScanRoute = LocaleTravelScanRouteImport.update({
            id: '/travel-scan',path: '/travel-scan',getParentRoute: () => LocaleRouteRoute
          })
const LocaleVaccinationChecklistRoute = LocaleVaccinationChecklistRouteImport.update({
            id: '/vaccination-checklist',path: '/vaccination-checklist',getParentRoute: () => LocaleRouteRoute
          })
const LocaleBlogIndexRoute = LocaleBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => LocaleRouteRoute
          })
const LocaleBlogSlugRoute = LocaleBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => LocaleRouteRoute
          })
const LocaleTravelIndexRoute = LocaleTravelIndexRouteImport.update({
            id: '/travel/',path: '/travel/',getParentRoute: () => LocaleRouteRoute
          })
const LocaleTravelSlugRoute = LocaleTravelSlugRouteImport.update({
            id: '/travel/$slug',path: '/travel/$slug',getParentRoute: () => LocaleRouteRoute
          })
const LocaleTravelDiseasesIndexRoute = LocaleTravelDiseasesIndexRouteImport.update({
            id: '/travel/diseases/',path: '/travel/diseases/',getParentRoute: () => LocaleRouteRoute
          })
const LocaleTravelDiseasesSlugRoute = LocaleTravelDiseasesSlugRouteImport.update({
            id: '/travel/diseases/$slug',path: '/travel/diseases/$slug',getParentRoute: () => LocaleRouteRoute
          })





const LocaleRouteRouteChildren = {
  LocaleAboutRoute: LocaleAboutRoute,LocaleAccountRoute: LocaleAccountRoute,LocaleAppRoute: LocaleAppRoute,LocaleBoosterRemindersRoute: LocaleBoosterRemindersRoute,LocaleCommunityRoute: LocaleCommunityRoute,LocaleContactRoute: LocaleContactRoute,LocaleCookiesRoute: LocaleCookiesRoute,LocaleDeleteAccountRoute: LocaleDeleteAccountRoute,LocaleDevelopersRoute: LocaleDevelopersRoute,LocaleFaqRoute: LocaleFaqRoute,LocaleLoginRoute: LocaleLoginRoute,LocaleMediaRoute: LocaleMediaRoute,LocalePrivacyRoute: LocalePrivacyRoute,LocaleRegisterRoute: LocaleRegisterRoute,LocaleTermsRoute: LocaleTermsRoute,LocaleTravelScanRoute: LocaleTravelScanRoute,LocaleVaccinationChecklistRoute: LocaleVaccinationChecklistRoute,LocaleIndexRoute: LocaleIndexRoute,LocaleBlogSlugRoute: LocaleBlogSlugRoute,LocaleTravelSlugRoute: LocaleTravelSlugRoute,LocaleBlogIndexRoute: LocaleBlogIndexRoute,LocaleTravelIndexRoute: LocaleTravelIndexRoute,LocaleTravelDiseasesSlugRoute: LocaleTravelDiseasesSlugRoute,LocaleTravelDiseasesIndexRoute: LocaleTravelDiseasesIndexRoute
}

const LocaleRouteRouteWithChildren = LocaleRouteRoute._addFileChildren(LocaleRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LocaleRouteRoute: LocaleRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)